import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SavePartyInput_InputAdapter_instanceergmyw6zfzfp as SavePartyInput_InputAdapter_instance } from '../type/adapter/SavePartyInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePartyMutation_VariablesAdapterClass;
function SavePartyMutation_VariablesAdapter() {
  if (SavePartyMutation_VariablesAdapterClass === VOID) {
    class $ {
      j6i(writer, value, customScalarAdapters, withDefaultValues) {
        writer.t48('input');
        obj(SavePartyInput_InputAdapter_instance).r40(writer, customScalarAdapters, value.i6i_1);
      }
    }
    initMetadataForObject($, 'SavePartyMutation_VariablesAdapter');
    SavePartyMutation_VariablesAdapterClass = $;
  }
  return SavePartyMutation_VariablesAdapterClass;
}
var SavePartyMutation_VariablesAdapter_instance;
function SavePartyMutation_VariablesAdapter_getInstance() {
  return SavePartyMutation_VariablesAdapter_instance;
}
//region block: init
SavePartyMutation_VariablesAdapter_instance = new (SavePartyMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SavePartyMutation_VariablesAdapter_instance as SavePartyMutation_VariablesAdapter_instance1bfjwovek9riw,
};
//endregion

//# sourceMappingURL=SavePartyMutation_VariablesAdapter.mjs.map
